<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <b-row >
      <b-col sm="12">
        <b-row>
          <b-col cols="3">
            <h4>Roles</h4>
            <b-row>
              <b-col cols="6">
                <b-form-group id="fieldsetHorizontal" horizontal breakpoint="md">
                  <b-form-input type="text" v-model="descrRol"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-button
                  style="display:block;margin:auto;"
                  size="sm"
                  variant="success"
                  @click="crearRol(descrRol)"
                >
                  <i class="fa fa-floppy-o"></i> Crear
                </b-button>
              </b-col>
              <br />

              <b-col cols="12">
                <b-form-group v-for="(rol,index) in roles" :key="index">
                  <b-form-radio
                    v-model="rolusuario"
                    name="some-radios"
                    :id="'rol'+rol.id"
                    :value="rol.id"
                    @change="getPermisosPorRoles(rol.id)"
                  >
                    <label :for="'rol'+rol.id">
                      <span v-if="rolusuario != rol.id">{{rol.descripcion}}</span>
                      <b v-else>{{rol.descripcion}}</b>
                    </label>
                  </b-form-radio>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-button
                  v-if="rolusuario != ''"
                  style="display:block;margin:auto;"
                  size="sm"
                  variant="primary"
                  @click="guardaPermisosRol()"
                >
                  <i class="fa fa-floppy-o"></i> Guardar
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="9">
            <h4>Permisos</h4>
            <div class="permisos">
              <b-row>
                <b-col cols="4">
                    <input
                      type="text"
                      v-model="buscarPermiso"
                      placeholder="Permiso..."
                      class="form-control"
                      cols="lg"
                    />
                </b-col>
                 <b-col cols="4">
                    <input
                      type="text"
                      v-model="keyDesc"
                      placeholder="Key..."
                      class="form-control"
                      cols="lg"
                    />
                </b-col>
                <b-col cols="4">
                <b-button @click.prevent="limpiar()">
                <i class="fa fa-eraser fa-lg"></i> Limpiar
                </b-button>
                </b-col>
                </b-row>
                <b-row class="pt-3 pb-3">
                  <b-col cols="2">
                    <b-button
                      style="display:block;margin:auto;"
                      size="sm"
                      variant="success"
                      @click="filtrarPermiso()"
                    >
                      <i class="fa fa-search"></i> Buscar
                    </b-button>
                  </b-col>
                 <b-col cols="2" >
                    <b-button
                      v-if="buscarPermiso!='' || keyDesc!=''"
                      style="display:block;margin:auto;"
                      size="sm"
                      variant="primary"
                      @click="guardarPermisos(buscarPermiso, keyDesc)"
                    >
                      <i class="fa fa-plus"></i> Crear
                    </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="10">
                  <ul
                    style="margin: 0px;padding:0;"
                    v-for="(permiso,index2) in permisos"
                    :key="index2"
                  >
                    <li>
                      <b-form-group>
                        <b-col class="d-flex">
                          <b-form-checkbox
                          v-model="permisosSeleccionados"
                          :value="permiso.id"
                          :unchecked-value="permisoCheck(permisosSeleccionados.indexOf(permiso.id))"
                          @change="cambiaPermiso(permiso.id)"
                          ></b-form-checkbox>
                          <a v-b-tooltip.hover title="Editar Permiso"
                           @click="editarPermiso(index2)">
                            <i class="fa fa-edit fa-lg"></i>
                          </a>
                          <b-col v-if="!permiso.editable">
                            {{permiso.id}}) <b>{{permiso.descripcion}}</b> - <i>{{permiso.key}}</i>
                          </b-col>
                          <b-col v-if="permiso.editable">
                            <b-form @submit.prevent="actualizarPermisos(index2)">
                              <b-form-group>
                                <b-form-input
                                  type="text"
                                  v-model="permiso.descripcion"
                                  required
                                />   
                              </b-form-group>
                                <b-button variant="success" type="submit">
                                  Guardar
                                </b-button>                                     
                            </b-form>
                          </b-col>
                        </b-col>
                      </b-form-group>                        
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import loader from './../../containers/loader';

export default {
  name: "roles-permisos",
  data() {
    return {
      descrRol: '',
      buscarPermiso: '',
      keyDesc: '',
      permisoEditado: '',
      loading: false,
      edicionAnterior: {
        indice: -1,
        descripcion: ''
      },
      editandoPermiso: false,
      datos:{
        descripcion:'',
        key:'',
      }
    };
  },
  components: {
    loader
  },
  updated() {},
  computed: {
    ...mapState("administracion", [
      "descripcionRol",
      "roles",
      "permisos",
      "buscaPermiso",
      "permisosSeleccionados",
      "rolusuario"
    ])
    /**  */
  },
  methods: {
    permisoCheck(check) {
      if (check == -1) {
        return false;
      } else {
        return true;
      }
    },
    async limpiar() {
      this.buscarPermiso = '';
      this.keyDesc = '';
      await this.filtrarPermiso();
    },
    async guardarPermisos(permiso,key){
      this.datos.descripcion =permiso
      this.datos.key = key
      this.buscarPermiso = '';
      this.keyDesc = '';
      await this.crearPermiso(this.datos)
      await this.getPermisosFiltro();
    },
    async editarPermiso(indice) {
      
      if ( this.edicionAnterior.indice >= 0) {
        let indiceAnterior = this.edicionAnterior.indice;
        this.permisos[indiceAnterior].editable = false;
        this.permisos[indiceAnterior].descripcion = this.edicionAnterior.descripcion;
      }
      this.permisos[indice].editable = true;  
      this.edicionAnterior.indice = indice;
      this.edicionAnterior.descripcion = this.permisos[indice].descripcion;
    },
    async getPermisosPorRoles(id) {
      this.loading = true;
      await this.getPermisosPorRol(id);
      this.loading = false;
    },
    async actualizarPermisos(indice) {
      this.edicionAnterior.indice = -1;
      this.edicionAnterior.descripcion = '';
      let permiso = new FormData();
      permiso.append('descripcion', this.permisos[indice].descripcion);
      permiso.append('id', this.permisos[indice].id);

      this.loading = true;
      await this.actualizarPermiso(permiso);
      this.loading = false;
    },
    async filtrarPermiso() {
      var busca = {
        permiso: this.buscarPermiso,
        key: this.keyDesc
      };
      this.filtroPermiso(busca);
      this.loading = true;
      await this.getPermisosFiltro();
      this.loading = false;
    },
    ...mapActions("administracion", [
      "getPermisosFiltro",
      "getPermisosPorRol",
      "guardaPermisosRol",
      "eliminaPermisosRol",
      "actualizarPermiso",
      "crearRol",
      "crearPermiso"
    ]),
    ...mapMutations("administracion", ["filtroPermiso", "cambiaPermiso","cambiaDescripcionRol", "cambiaDescripcion"])
  }
};
</script>

<style scoped>
.permisos {
  display: block;
  height: 400px;
  overflow: scroll;
}
</style>
